<div class="flex flex-col bgi-no-repeat rounded-t-xl">
  <div class="flex flex-col bgi-no-repeat rounded-t-xl bg-primary">
    <div class="flex justify-around items-center mt-10 mb-6">
      <h6 class="!text-white">
        {{"NOTIFICATION.NOTIFICATION" | translate}}
        <span class="text-sm opacity-75 ps-3"
          >{{ notifications().length }} {{"NOTIFICATION.NEW" | translate}}</span
        >
      </h6>
      @if(notifications().length>0){
      <button
        pButton
        [size]="'small'"
        [severity]="'secondary'"
        (click)="clearNotifications()"
      >
        x
      </button>
      }
    </div>
  </div>
  <div class="overflow-y-auto max-h-[325px] my-5 px-8">
    @for(notification of notifications();track $index){
    <div class="flex items-center py-4">
      <div class="flex items-center">
        <div class="mb-0 me-2">
          <span class="text-base !text-gray-800 hover:text-primary !font-bold">
            {{ notification.summary }}
          </span>
          <div class="text-gray-500 text-sm">{{ notification.detail }}</div>
        </div>
      </div>

      <button
        pButton
        [size]="'small'"
        (click)="clearNotifications(notification.id)"
      >
        x
      </button>
    </div>
    }@empty {
    <div class="w-full text-center">
      <span class="font-semibold">{{"NOTIFICATION.NO_NOTIFICATION" | translate}}</span>
    </div>
    }
  </div>
</div>
